<template>
  <div
    class="
      col-span-6
      sm:col-span-3
      xl:col-span-2
      flex flex-col
      justify-end
      items-center
    "
    v-if="loading"
  >
    <LoadingIcon icon="three-dots" class="w-8 h-8" />
  </div>
  <div v-if="!loading">
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <BookmarkIcon />
      <h2 class="text-lg font-medium mr-auto">{{ $t('service.detail') }}</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <router-link
          :to="{ name: 'side-menu-services' }"
          tag="a"
          class="btn shadow-md flex items-center"
        >
          <ArrowLeftCircleIcon class="w-4 h-4 mr-2" /> {{ $t('common.back') }}
        </router-link>
      </div>
    </div>
    <div class="intro-y box px-5 pt-5 mt-5">
      <div
        class="
          flex flex-col
          lg:flex-row
          border-b border-gray-200
          dark:border-dark-5
          pb-5
          -mx-5
        "
      >
        <div
          class="flex flex-1 px-5 items-center justify-center lg:justify-start"
        >
          <div
            class="
              w-20
              h-20
              sm:w-24 sm:h-24
              flex-none
              lg:w-32 lg:h-32
              image-fit
              relative
            "
          >
            <img
              alt="Service image"
              class="rounded-full"
              :src="service.image"
              v-if="service.image"
            />
          </div>
          <div class="ml-5">
            <div
              class="
                w-24
                sm:w-40
                truncate
                sm:whitespace-normal
                font-medium
                text-lg
              "
            >
              {{ service.name.sk_SK }}
            </div>
            <div class="text-gray-600">
              {{ service.description.sk_SK }}
            </div>
          </div>
        </div>
        <div
          class="
            mt-6
            lg:mt-0
            flex-1
            dark:text-gray-300
            px-5
            border-l border-r border-gray-200
            dark:border-dark-5
            border-t
            lg:border-t-0
            pt-5
            lg:pt-0
          "
        >
          <div class="font-medium text-center lg:text-left lg:mt-3">
            {{ $t('common.detail') }}
          </div>
          <div
            class="
              flex flex-col
              justify-center
              items-center
              lg:items-start
              mt-4
            "
          >
            <div class="truncate sm:whitespace-normal flex items-center">
              {{
                $t(
                  'reservationStrategy.' +
                    service.reservationStrategy.replaceAll('-', '_')
                )
              }}
            </div>
            <div class="truncate sm:whitespace-normal flex items-center">
              <WatchIcon class="w-4 h-4 mr-2" />
              {{ service.timeBefore + service.duration + service.timeAfter }}min
              ({{ service.timeBefore }} min +
              {{ service.duration === null ? '&#8734;' : service.duration }} min
              + {{ service.timeAfter }} min)
            </div>
            <div
              class="truncate sm:whitespace-normal flex items-center mt-3"
              v-if="service.price"
            >
              <DollarSignIcon class="w-4 h-4 mr-2" />
              {{ price.type?.name['sk_SK'] }} {{ price.amount }}
              {{ price.currency }} {{ price.unit?.name['sk_SK'] }}
            </div>
            <div class="truncate sm:whitespace-normal flex items-center mt-3">
              <EyeIcon class="w-4 h-4 mr-2" v-if="service.visible" />
              <EyeOffIcon class="w-4 h-4 mr-2" v-if="!service.visible" />
              {{ $t('common.visibility') }}
            </div>
            <div class="truncate sm:whitespace-normal flex items-center mt-3">
              <CheckCircleIcon class="w-4 h-4 mr-2" v-if="service.active" />
              <CircleIcon class="w-4 h-4 mr-2" v-if="!service.active" />
              {{ $t('common.active') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="intro-y box px-5 pt-5 mt-5">
      <div
        class="
          flex flex-col
          lg:flex-row
          pb-5
          -mx-5
        "
      >
        <div
          class="flex flex-1 px-5 items-center justify-center lg:justify-start"
        >
          <div class="truncate sm:whitespace-normal flex items-center">
            <BranchBindList :selectedBranches="service.branches" />
          </div>
        </div>
        <div
          class="
            mt-6
            lg:mt-0
            flex-1
            dark:text-gray-300
            px-5
            border-l border-r border-gray-200
            dark:border-dark-5
            border-t
            lg:border-t-0
            pt-5
            lg:pt-0
          "
          v-if="service.reservationStrategy === 'service-employee'"
        >
          <div class="truncate sm:whitespace-normal flex items-center">
            <EmployeeBindList :selectedEmployees="service.employees" />
          </div>
        </div>
        <div
          class="
            mt-6
            lg:mt-0
            flex-1
            dark:text-gray-300
            px-5
            border-l border-r border-gray-200
            dark:border-dark-5
            border-t
            lg:border-t-0
            pt-5
            lg:pt-0
          "
          v-if="
            service.reservationStrategy === 'service-resource-date' ||
              service.reservationStrategy === 'service-resource-date-range'
          "
        >
          <div class="truncate sm:whitespace-normal flex items-center">
            <ResourceBindList :selectedResources="service.resources" />
          </div>
        </div>
        <div
          class="
            mt-6
            lg:mt-0
            flex-1
            dark:text-gray-300
            px-5
            border-l border-r border-gray-200
            dark:border-dark-5
            border-t
            lg:border-t-0
            pt-5
            lg:pt-0
          "
          v-if="
            service.reservationStrategy === 'service-branch-place-date' ||
              service.reservationStrategy === 'service-branch-place-date-range'
          "
        >
          <div class="truncate sm:whitespace-normal flex items-center">
            <BranchPlaceBindList :selectedBranchPlaces="service.branchPlaces" />
          </div>
        </div>
      </div>
    </div>
    <div class="intro-y box p-5 mt-5">
      <Calendar :service="this.$route.params.uuid" />
    </div>
  </div>
  <!-- BEGIN: Failed Notification Content -->
  <div
    id="failed-load-notification-content"
    class="toastify-content hidden flex"
  >
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('service.notLoaded') }}!</div>
      <!-- <div class="text-gray-600 mt-1">Please check the fileld form.</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent, ref } from 'vue'
import Toastify from 'toastify-js'
import serviceApi from '@/services/services/service.api'
import Calendar from '../../components/reservations/Calendar.vue'
import BranchBindList from '@/components/branches/BranchBindList.vue'
import BranchPlaceBindList from '@/components/branches/BranchPlaceBindList.vue'
import EmployeeBindList from '@/components/employees/EmployeeBindList.vue'
import ResourceBindList from '@/components/resources/ResourceBindList.vue'

export default defineComponent({
  components: {
    Calendar,
    BranchBindList,
    BranchPlaceBindList,
    EmployeeBindList,
    ResourceBindList
  },
  methods: {},
  computed: {
    console: () => console
  },
  data() {
    return {
      service: {},
      price: {
        type: null,
        unit: null,
        amount: null,
        currency: null
      }
    }
  },
  mounted() {
    serviceApi.getDetail(this.$route.params.uuid).then(
      response => {
        this.service = response.data

        serviceApi.getPriceAttributeList().then(
          response => {
            this.price.type = response.data.types.find(
              priceType => priceType.code === this.service.price.type
            )
            this.price.unit = null
            if (this.service.price.unit !== null) {
              this.price.unit = response.data.units.find(
                priceUnit => priceUnit.code === this.service.price.unit
              )
            }
            if (this.service.price.amount !== null) {
              const amount = this.service.price.amount
              this.price.amount = amount === null ? '' : amount / 100
            }
            if (this.service.price.currency !== null) {
              this.price.currency = this.service.price.currency
            }
          },
          error => {
            console.log(error)
          }
        )

        this.loading = false
      },
      error => {
        console.log(error)
        Toastify({
          node: cash('#failed-load-notification-content')
            .clone()
            .removeClass('hidden')[0],
          duration: 10000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        this.$router.push({ name: 'side-menu-services' })
      }
    )
  },
  setup() {
    const loading = ref(true)
    return {
      loading
    }
  }
})
</script>
